import * as React from "react"
import { StaticImage } from "gatsby-plugin-image";

import * as S from './styles';

export default function Footer({setModal}) {
  return (
    <S.Container>
      <StaticImage
        src={`../../images/footer.png`}
        alt="Background footer"
        placeholder="blurred"
        layout="constrained"
      />
      <S.ContainerInfo>
        <S.DivInfo>
          <S.Info>©2021 Talent Juice Ltd</S.Info>
          <S.NavFooter>
            <S.NavLink to="#">Home</S.NavLink>
            •
            <S.NavLink to="#" rel="noreferrer">System</S.NavLink> */}
            {/* • */}
            {/* <S.NavLink to="#" rel="noreferrer">About</S.NavLink> */}
            {/* • */}
            <S.NavLink to="#" rel="noreferrer" onClick={() => setModal(true)}>Contact</S.NavLink>
          </S.NavFooter>
        </S.DivInfo>
      </S.ContainerInfo>
    </S.Container>
  )
}